export enum SCREEN_BREAKPOINTS {
  'SMALL' = 576,
  'MEDIUM' = 768,
  'LARGE' = 992,
  'EXTRA_LARGE' = 1200
}
